<template>
  <vddl-list
    :list="tlist"
    :allowed-types="allowedTypes"
    class="overlay_container"
  >
    <base-modal
      :title="'Element properties'"
      :inner-modal="true"
      @close-modal="onCloseModal"
    >
      <Tabs :tab-list="['Attributes', 'Details']">
        <template #tabPanel-1>
          <attribute-list container-type="elements" :container-id="element" />
        </template>
        <template #tabPanel-2>
          <div class="wrapper clearfix">
            <table class="tbl">
              <tbody>
                <tr>
                  <td class="left">Word count</td>
                  <td class="right">
                    <span>
                      {{ wordCount }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </Tabs>
    </base-modal>
  </vddl-list>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AttributeList from '@/components/all/Attributes/AttributeList.vue';
import Tabs from '@/components/all/Tabs/Tabs.vue';
import { DRAG_TYPE } from '@/constants.js';
import { countWords } from '../../../utils.js';
import BaseModal from '../BaseModal.vue';

export default {
  components: {
    BaseModal,
    Tabs,
    AttributeList,
  },

  data() {
    return {
      tlist: [],
      allowedTypes: [DRAG_TYPE.ATTRIBUTE_COMPONENT, DRAG_TYPE.ATTRIBUTE_ASSET],
      drag: false,
    };
  },

  computed: {
    ...mapGetters('application/modals', ['getElementPropertiesModal']),
    ...mapGetters('project/data/elements', ['getNode', 'getContainedNodes']),
    /**
     * Return the element id for which to show the board properties
     * @return {String}     The board id
     */
    element() {
      return this.getElementPropertiesModal;
    },

    /**
     * Return the number of words in this element
     * @return {number}     The number of words in the element
     */
    wordCount() {
      let count = 0;
      // Count the words in content of each board element
      const { title, content } = this.getNode(this.element);
      count += countWords(title) + countWords(content);

      return count;
    },
  },

  methods: {
    ...mapActions('application/modals', ['setElementPropertiesModal']),

    /**
     * Event listener for pressing the close button
     */
    onCloseModal() {
      this.setElementPropertiesModal({ value: null });
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  padding: 0 20px 20px;
  .label {
    color: #828585;
    font-size: 15px;
    padding: 20px 0;
  }
  .empty {
    // background: #ccc;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    border: 1px solid #41494b;
  }
  &.clearfix::after {
    content: '';
    clear: both;
    display: table;
  }
}

.tbl {
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  margin: 15px 0 10px 0;
  font-size: 15px;
  table-layout: fixed;

  tr {
    vertical-align: top;

    td {
      padding: 0;
      height: 50px;
      text-align: left;
      vertical-align: middle;
      box-sizing: border-box;
      &.right span {
        color: #fff;
        font-weight: 600;
      }
      &.left {
        color: #828585;
        width: 100px;
      }
    }
  }
}
</style>
